import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=6dc4afb4&scoped=true&"
import script from "@/scripts/Home/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Home/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc4afb4",
  null
  
)

export default component.exports